export function getRatio(
  chargedAt: Date,
  periodByMinute: number,
  baseDate = new Date()
): number {
  if (baseDate >= chargedAt) {
    return 1;
  }
  const remainMinutes = (chargedAt.getTime() - baseDate.getTime()) / 1000 / 60;
  return Number(((periodByMinute - remainMinutes) / periodByMinute).toFixed(2));
}
